module.exports = __webpack_public_path__ + "assets/img/ic-other-card.4a623601.svg";